var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 0H5.67C2.28 0 0 2.38 0 5.92V14.09C0 17.62 2.28 20 5.67 20H14.34C17.73 20 20 17.62 20 14.09V5.92C20 2.38 17.73 0 14.34 0Z",
    className: "bg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0163 11.7705L11.2373 9.9925L13.0153 8.2145C13.3573 7.8735 13.3573 7.3185 13.0153 6.9775C12.6733 6.6335 12.1203 6.6345 11.7783 6.9765L9.99931 8.7545L8.22031 6.9745C7.87831 6.6325 7.32431 6.6345 6.98231 6.9745C6.64131 7.3165 6.64131 7.8715 6.98231 8.2125L8.76231 9.9925L6.98631 11.7675C6.64431 12.1095 6.64431 12.6645 6.98631 13.0045C7.15731 13.1765 7.38031 13.2615 7.60431 13.2615C7.82931 13.2615 8.05231 13.1765 8.22331 13.0055L9.99931 11.2295L11.7793 13.0085C11.9503 13.1795 12.1733 13.2645 12.3973 13.2645C12.6213 13.2645 12.8453 13.1785 13.0163 13.0085C13.3583 12.6665 13.3583 12.1125 13.0163 11.7705Z",
    className: "fg"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.eb16b62b14d44f1df4e5dd64ee3e87cc.svg";
export { ForwardRef as ReactComponent };